var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import Vue from 'vue';
import { Component, Inject, Watch, Ref } from 'vue-property-decorator';
import LoaderBox from 'common/UIToolKit/layout/LoaderBox.vue';
import EmptyState from 'ui/v1/EmptyState.vue';
import AppLink from 'ui/v1/navigation/AppLink.vue';
import { TalentFileService } from 'packages/talent/TalentFileService';
import { container } from 'tsyringe';
import UiSelectFileButton from 'ui/v1/controls/UiSelectFileButton.vue';
import UploadProgressBar from 'ui/v1/UploadProgressBar.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import { Talent } from 'packages/talent/entities/Talent';
import { TalentFileUpload } from 'packages/files/TalentFileUpload';
import { FileTooLargeException, InvalidFileTypeException } from 'packages/core/files/exceptions';
import { DOC_FILE_TYPES, IMAGE_FILE_TYPES } from 'common/services/FileService';
import Thumbnail from 'ui/v1/file/Thumbnail.vue';
import { Getter, namespace } from 'vuex-class';
import { Job } from 'packages/v3/jobs/Job';
import { Candidate, CandidateCategory } from 'packages/v3/jobs/Candidate';
var talentCardModule = namespace('talentCard');
var jobsModule = namespace('jobs');
var TalentFilesView = /** @class */ (function (_super) {
    __extends(TalentFilesView, _super);
    function TalentFilesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.files = [];
        _this.loading = false;
        _this.fileService = container.resolve(TalentFileService);
        _this.uploading = false;
        _this.uploads = [];
        _this.allowedFiles = __spreadArray(__spreadArray([], IMAGE_FILE_TYPES), DOC_FILE_TYPES);
        _this.maxSize = 25;
        return _this;
    }
    Object.defineProperty(TalentFilesView.prototype, "allowedFileTypes", {
        get: function () {
            return this.allowedFiles.map(function (type) { return "." + type; }).join(',');
        },
        enumerable: false,
        configurable: true
    });
    TalentFilesView.prototype.handleFileDeleted = function (fileId) {
        this.files = this.files.filter(function (file) { return file.id !== fileId; });
        this.fileService.total -= 1;
        /*
        Once at least single file exists, the route falls from TalentCard.Files to nested TalentCard.ViewFile
        talentCard routes are reused multiple times with same naming with routeNamePrefix, thus calling $router.push({ name: TalentCard.Files })
        will not redirect to direct parent; match is used here to get the first parent of current route.
        The goal is to remove file param from URL.
        */
        if (this.files.length === 0) {
            var newRoute = this.$route.matched[this.$route.matched.length - 2];
            return this.$router.push(newRoute);
        }
        this.navigateToLatestFile();
        this.fileListNav.scrollTo({ top: 0, behavior: 'smooth' });
    };
    TalentFilesView.prototype.getFilesForTalent = function () {
        var _this = this;
        var _a;
        this.fileService.allFilesForTalent(this.talent.id, true, this.candidateIsolationEnabledOrNil ? (_a = this.job) === null || _a === void 0 ? void 0 : _a.id : null)
            .then(function (files) {
            _this.files = files;
            if (_this.files.length > 0 && _this.$route.name.includes('TalentCard.Files')) {
                _this.navigateToLatestFile(true);
            }
        })
            .finally(function () { return _this.loading = false; });
    };
    TalentFilesView.prototype.navigateToLatestFile = function (append) {
        if (append === void 0) { append = false; }
        this.$router.push({ path: "" + this.files[0].id, append: append });
    };
    TalentFilesView.prototype.filesSelected = function (files) {
        var _this = this;
        var _a, _b, _c;
        if (!files.length) {
            return;
        }
        this.uploads = [];
        this.uploads = Array.from(files).map(function (file) {
            var fileUpload = new TalentFileUpload(file);
            try {
                fileUpload.validate(_this.maxSize, _this.allowedFiles);
            }
            catch (error) {
                if (error instanceof FileTooLargeException) {
                    _this.fileTooLargeMessage(file.name);
                }
                else if (error instanceof InvalidFileTypeException) {
                    _this.fileTypeNotAllowedMessage(file.name);
                }
                return;
            }
            fileUpload.upload(_this.talent.id, _this.job.id).then(function (result) { return result; }).catch(function (error) {
                if (error.code && error.code === 'ECONNABORTED') {
                    fileUpload.setTimedOut();
                    _this.$notify.toast(_this.$t('talent_card.files.upload_timeout', { name: file.name }), { type: 'warning' });
                }
                else {
                    _this.$notify.toast(_this.$t('talent_card.files.something_went_wrong', { name: file.name }), {
                        type: 'error',
                    });
                }
            });
            return fileUpload;
        }).filter(function (upload) { return upload; });
        this.$posthog.capture('File uploaded', {
            category: CandidateCategory[(_a = this.talent.score) !== null && _a !== void 0 ? _a : 0],
            pipelineStageType: (_c = (_b = this.job.stages) === null || _b === void 0 ? void 0 : _b.find(function (stage) { var _a; return stage.id === ((_a = _this.candidate) === null || _a === void 0 ? void 0 : _a.pipelineStage); })) === null || _c === void 0 ? void 0 : _c.type,
        });
        // Clear uploads and reload file list
        Promise.all(this.uploads.map(function (upload) { return upload.promise; })).finally(function () {
            _this.uploads = [];
            _this.getFilesForTalent();
        });
    };
    TalentFilesView.prototype.getTimeRemaining = function (seconds) {
        var mins = parseInt((seconds / 60).toString());
        var secs = seconds % 60;
        return (mins)
            ? this.$t('common.uploads.time_remaining_minutes_and_seconds', {
                minutes: mins,
                seconds: secs,
            })
            : this.$t('common.uploads.time_remaining_seconds', { seconds: seconds });
    };
    TalentFilesView.prototype.fileTooLargeMessage = function (name) {
        this.$notify.toast(this.$t('common.uploads.file_too_large', {
            name: name,
            maxSize: this.maxSize,
        }), { type: 'error' });
    };
    TalentFilesView.prototype.fileTypeNotAllowedMessage = function (name) {
        this.$notify.toast(this.$t('common.uploads.file_type_not_allowed', {
            name: name,
            fileTypes: this.allowedFileTypes,
        }), {
            type: 'error',
        });
    };
    TalentFilesView.prototype.setDropZone = function (evt) {
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        evt.preventDefault();
    };
    TalentFilesView.prototype.onDragEnter = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.$el.classList.add('dragged-over');
    };
    TalentFilesView.prototype.onDragLeave = function (evt) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.$el.classList.remove('dragged-over');
    };
    TalentFilesView.prototype.onDrop = function (evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.$el.classList.remove('dragged-over');
        this.filesSelected(evt.dataTransfer.files);
    };
    TalentFilesView.prototype.onTalentChanged = function () {
        this.loading = true;
        this.getFilesForTalent();
    };
    TalentFilesView.prototype.onRedundantNavigation = function () {
        if (!this.$route.params.file && this.files.length > 0) {
            this.navigateToLatestFile(true);
        }
    };
    var _a, _b, _c, _d;
    __decorate([
        Getter,
        __metadata("design:type", Boolean)
    ], TalentFilesView.prototype, "candidateIsolationEnabledOrNil", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_a = typeof Talent !== "undefined" && Talent) === "function" ? _a : Object)
    ], TalentFilesView.prototype, "talent", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_b = typeof Candidate !== "undefined" && Candidate) === "function" ? _b : Object)
    ], TalentFilesView.prototype, "candidate", void 0);
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_c = typeof Job !== "undefined" && Job) === "function" ? _c : Object)
    ], TalentFilesView.prototype, "job", void 0);
    __decorate([
        Inject(),
        __metadata("design:type", String)
    ], TalentFilesView.prototype, "routeNamePrefix", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", typeof (_d = typeof Element !== "undefined" && Element) === "function" ? _d : Object)
    ], TalentFilesView.prototype, "fileListNav", void 0);
    __decorate([
        Watch('talent', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TalentFilesView.prototype, "onTalentChanged", null);
    __decorate([
        Watch('$route', { deep: true, immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TalentFilesView.prototype, "onRedundantNavigation", null);
    TalentFilesView = __decorate([
        Component({
            components: {
                Thumbnail: Thumbnail,
                Icon: Icon,
                UploadProgressBar: UploadProgressBar,
                UiSelectFileButton: UiSelectFileButton,
                AppLink: AppLink,
                EmptyState: EmptyState,
                LoaderBox: LoaderBox,
            },
        })
    ], TalentFilesView);
    return TalentFilesView;
}(Vue));
export default TalentFilesView;
